<app-cv-colf-template [isProduction]="isProduction" [mailServiceURL]="mailServiceURL" [showModal]="true" [colf]="colf"></app-cv-colf-template>

